import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { colors as colorsDefault } from "../../../constants/utils"
import ColorBtn from '../../LeftWorkArea/LeftWorkColor/ColorBtn';

import './colorArray.scss'

export type Color = { color: string, label: string }

interface IColorArray {
    colors?: { color: string, label: string }[]
    onColorSelected: (color: Color) => void,
    defaultColor: Color|null
}

export const ColorArray = (props: IColorArray) => {
    const { onColorSelected, defaultColor, colors = colorsDefault } = props

    const [selectedColor, setSelectedColor] = useState(defaultColor);
    
    const handleSelectColor = useCallback(({ target }) => {
        const color = {
            color: target.dataset.color,
            label: target.dataset.title,
        }
        setSelectedColor(color);
        onColorSelected(color);
    }, [])

    const renderColors = useMemo(
        () =>
            colors.map(item => (
                <ColorBtn
                    key={item.color}
                    color={item.color}
                    title={item.label}
                    active={selectedColor ? (selectedColor.color === item.color):false}
                    handler={handleSelectColor}
                />
            )),
        [selectedColor, handleSelectColor, colors],
    )

    return <div className='color-array'>
        {renderColors}
    </div>
}